import { render, staticRenderFns } from "./ContactChannelDashboard.vue?vue&type=template&id=f244c544&scoped=true&"
import script from "./ContactChannelDashboard.vue?vue&type=script&lang=js&"
export * from "./ContactChannelDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f244c544",
  null
  
)

export default component.exports